import { createStore } from '@stencil/store';
import rootJson from '../../../../common/hair-quiz-vto/root/root.json';
import config from '../root/config';
import { v1 as uuidv1 } from 'uuid';

import { getStateFromLocalStorage, saveStateToLocalStorage } from '../../../../common/hair-quiz-vto/utils/webstorage';

const enum WebStorageKey {
  i18n = 'i18n',
  state = 'state',
}
function getWebStorageKey(identifier: string): string {
  const {
    brand: { version, locale, brand, journey_type },
  } = config;

  return `aiba.${brand}.${locale.toLowerCase()}.${journey_type}.${version}.${identifier}`;
}
const STATE_WEB_STORAGE_KEY = getWebStorageKey(WebStorageKey.state);
const journeys = rootJson.map(e => {
  return e.value;
});

const INITIAL_STATE = {
  journey: 'quiz',
  currentJourney: journeys[0],
  currentIntroIndex: 0,
  currentQuizIndex: 0,
  quizData: {},
  showIntro: true,
  showQuiz: false,
  selectedOptions: [],
  quizPlainIndex: 0,
  breadCrumbState: [],
  quizFormattedData: [],
  quizPayload: [],
  RecommendedProducts: [],
  userName: '',
  i18nData: {},
  gender: '',
  config: '',
  userProfile: {
    username: uuidv1(),
  },
  newsletterSkipStatus: true,
  style: {
    activeTab: '',
    selectedStyleId: '',
    trackstyles: [],
    selectedStyleTab: '',
  },
  keepPhoto: false,
  showResultPage: false,
  showResultScreen: false,
  recommendedStyles: [],
};
const store = createStore(initState(), shouldWebStorageUpdate);
export const getState = () => {
  return store.state;
};
export default store.state;
function initState() {
  const previouslyEvauatedResults = getStateFromLocalStorage(STATE_WEB_STORAGE_KEY);
  if (previouslyEvauatedResults) {
    return previouslyEvauatedResults;
  } else {
    saveStateToLocalStorage(INITIAL_STATE, STATE_WEB_STORAGE_KEY);

    return INITIAL_STATE;
  }
}

function shouldWebStorageUpdate(newValue, oldValue, propChanged: string) {
  const shouldUpdateState = JSON.stringify(newValue) !== JSON.stringify(oldValue);

  if (shouldUpdateState) {
    saveStateToLocalStorage({ ...store.state, [propChanged]: newValue }, STATE_WEB_STORAGE_KEY);
  }

  return shouldUpdateState;
}
